import React, { useState } from 'react';

function PotoSettingsModal({ isOpen, onClose, onConfirm }) {
    const [quality, setQuality] = useState('medium');
    const [sensor, setSensor] = useState('back');

    if (!isOpen) return null;

    const handleSubmit = () => {
        onConfirm(quality, sensor);
        onClose();
    };

    const radioBoxStyle = {
        border: '1px solid #444',
        borderRadius: '4px',
        padding: '10px',
        marginBottom: '15px'
    };

    const radioLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    };

    const radioInputStyle = {
        marginRight: '8px'
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" style={{ maxWidth: '400px' }} onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h4>Настройки снимка</h4>
                </div>
                <div className="modal-body">
                    <div style={radioBoxStyle}>
                        <h5 style={{ marginTop: 0, marginBottom: '10px', color: '#ccc' }}>Сенсор:</h5>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <label style={radioLabelStyle}>
                                <input type="radio" name="sensor" value="back" checked={sensor === 'back'} onChange={() => setSensor('back')} style={radioInputStyle} />
                                Основная
                            </label>
                            <label style={radioLabelStyle}>
                                <input type="radio" name="sensor" value="front" checked={sensor === 'front'} onChange={() => setSensor('front')} style={radioInputStyle} />
                                Фронтальная
                            </label>
                        </div>
                    </div>

                    <div style={radioBoxStyle}>
                        <h5 style={{ marginTop: 0, marginBottom: '10px', color: '#ccc' }}>Качество:</h5>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <label style={radioLabelStyle}>
                                <input type="radio" name="quality" value="fast" checked={quality === 'fast'} onChange={() => setQuality('fast')} style={radioInputStyle} />
                                Низкое
                            </label>
                             <label style={radioLabelStyle}>
                                <input type="radio" name="quality" value="medium" checked={quality === 'medium'} onChange={() => setQuality('medium')} style={radioInputStyle} />
                                Среднее
                            </label>
                             <label style={radioLabelStyle}>
                                <input type="radio" name="quality" value="max" checked={quality === 'max'} onChange={() => setQuality('max')} style={radioInputStyle} />
                                Высокое
                            </label>
                        </div>
                    </div>
                </div>
                <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
                    <button onClick={onClose}>Отмена</button>
                    <button onClick={handleSubmit}>Сделать снимок</button>
                </div>
            </div>
        </div>
    );
}

export default PotoSettingsModal;